<template>
  <footer>
    <ul>
      <li><a href="/privacy_policy">プライバシポリシー</a></li>
      <li><a href="/term_of_use">利用規約</a></li>
      <li><a href="https://securelink-inc.co.jp/index.php">会社情報</a></li>
      <li><a href="/help">ヘルプ</a></li>
      <li><a href="/inquiry">お問い合わせ</a></li>
    </ul>
    <strong><span><i>事業再構築</i> &nbsp;Powered by</span><img src="@/assets/img/sl-logo.svg" alt="セキュアリンク株式会社" /></strong>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background-color: black;
}
</style>
